export default [
  [
    { text: 'гараж', model: 'hasGarage' },
    { text: 'бассейн', model: 'hasPool' },
    { text: 'терраса', model: 'hasTerrace', segment: 'house' },
  ],
  [
    { text: 'баня', model: 'hasBathhouse' },
    { text: 'охрана', model: 'hasSecurity' },
    { text: 'погреб', model: 'hasCellar', segment: 'house' },
  ],
];
